/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { AnimatedPlaceholderState, AnimatedPlaceholderSlots } from './AnimatedPlaceholder.types';

/**
 * Render the final JSX of AnimatedPlaceholder
 */
export const renderAnimatedPlaceholder_unstable = (state: AnimatedPlaceholderState): JSXElement => {
  assertSlots<AnimatedPlaceholderSlots>(state);

  return (
    <state.root>
      <state.motion>
        <state.placeholder />
      </state.motion>
    </state.root>
  );
};
